import React, { useState } from 'react';
import { exportTableToCSV, exportTableToExcel, generateTableFilename } from '../../utils/tableExport';
import './TableExportButton.css';

/**
 * TableExportButton Component
 *
 * Provides export functionality for AI-generated tables to CSV and Excel formats
 * Appears on hover over tables
 */
const TableExportButton = ({ tableMarkdown, hotelName }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (format) => {
    try {
      setIsExporting(true);
      const filename = generateTableFilename(tableMarkdown, hotelName);

      if (format === 'csv') {
        exportTableToCSV(tableMarkdown, filename);
      } else if (format === 'excel') {
        exportTableToExcel(tableMarkdown, filename);
      }

      // Close menu after successful export
      setTimeout(() => {
        setShowMenu(false);
      }, 100);
    } catch (error) {
      console.error('Export failed:', error);
      alert(`Failed to export table: ${error.message}`);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="table-export-container">
      <button
        className="table-export-button"
        onClick={() => setShowMenu(!showMenu)}
        disabled={isExporting}
        title="Export table"
      >
        {isExporting ? (
          <div className="export-spinner"></div>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
        )}
      </button>

      {showMenu && !isExporting && (
        <>
          <div className="export-menu-backdrop" onClick={() => setShowMenu(false)} />
          <div className="export-menu">
            <button
              className="export-menu-item"
              onClick={() => handleExport('csv')}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
                <polyline points="10 9 9 9 8 9"/>
              </svg>
              <span>Export to CSV</span>
            </button>
            <button
              className="export-menu-item"
              onClick={() => handleExport('excel')}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <path d="M8 13h2l2 3 2-3h2"/>
                <line x1="8" y1="17" x2="16" y2="17"/>
              </svg>
              <span>Export to Excel</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default TableExportButton;
